import {prepareRequest} from "../../index.js";
import {setParamsToURL} from "../../index.js"
import {STOCK_API_URL_LIST} from "../../routes/stock/index.js";
import store from '../../../state/store';

async function getSingleStock(params, body, urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(STOCK_API_URL_LIST.SINGLE_STOCK_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request, true);
}


async function getStockList({params, body, urlSegments, loading}) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(STOCK_API_URL_LIST.STOCK_LIST_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request, loading);
}

async function searchStockList({params, body, urlSegments, loading}) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(STOCK_API_URL_LIST.STOCK_SEARCH_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request, loading);
}

async function getStockCodes({params, body, urlSegments}) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(STOCK_API_URL_LIST.STOCK_CODES_LIST_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request);
}

async function getStockActionList(params, body, urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(STOCK_API_URL_LIST.STOCK_ACTION_LIST_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request, true);
}

async function getStockCategoryList(params, body, urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(STOCK_API_URL_LIST.CATEGORY_LIST_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request, true);
}

async function getCurrentStockActionList(params, body, urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(STOCK_API_URL_LIST.CURRENT_STOCK_ACTIONS_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request, true);
}

async function getStockCategorySingle(params, body, urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(STOCK_API_URL_LIST.CATEGORY_SINGLE_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request, true);
}

async function addStockCategory(params, body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(STOCK_API_URL_LIST.CATEGORY_ADD_URL, params),
        post: body
    }
    return prepareRequest(config, request);
}


async function updateStockCategory(params, body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(STOCK_API_URL_LIST.CATEGORY_UPDATE_URL, params),
        post: body
    }
    return prepareRequest(config, request);
}


async function deleteStockCategory(params, body, urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(STOCK_API_URL_LIST.CATEGORY_DELETE_URL, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request);
}

async function getStockImage(params, body, urlSegments, urlConcat) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(STOCK_API_URL_LIST.SINGLE_STOCK_IMAGE + '/' + urlConcat, params, urlSegments),
        post: body
    }
    return prepareRequest(config, request, false);
}

async function getEquivalentCodeList(params, body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(STOCK_API_URL_LIST.EQUIVALENT_CODE_LIST_URL, params),
        post: body
    }
    return prepareRequest(config, request);
}

async function addEquivalentCode(params, body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(STOCK_API_URL_LIST.ADD_EQUIVALENT_CODE_URL, params),
        post: body
    }
    return prepareRequest(config, request);
}

async function updateEquivalentCode(params, body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(STOCK_API_URL_LIST.UPDATE_EQUIVALENT_CODE_URL, params),
        post: body
    }
    return prepareRequest(config, request);
}

async function addProperty(params, body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(STOCK_API_URL_LIST.ADD_PROPERTY_URL, params),
        post: body
    }
    return prepareRequest(config, request);
}

async function updateProperty(params, body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(STOCK_API_URL_LIST.UPDATE_PROPERTY_URL, params),
        post: body
    }
    return prepareRequest(config, request);
}

async function deleteStockImage(params, body, urlSegments) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token,
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(STOCK_API_URL_LIST.DELETE_STOCK_IMAGE_URL, params, urlSegments),
        data: body
    }
    return prepareRequest(config, request);
}

export {
    getStockCategoryList,
    addStockCategory,
    updateStockCategory,
    deleteStockCategory,
    getStockCategorySingle,
    getCurrentStockActionList,
    getStockList,
    getStockActionList,
    getSingleStock,
    getStockImage,
    addEquivalentCode,
    updateEquivalentCode,
    getEquivalentCodeList,
    addProperty,
    updateProperty,
    searchStockList,
    getStockCodes,
    deleteStockImage,
};
